import * as React from 'react'
// hooks
import { useModalData } from 'hooks/index'
// components
import { DrawerModal } from 'components/UI'
// view components
import ReviewResultContainer from 'containers/Review/ReviewResult'
// constants
import { Modals } from 'constants/index'

const PAPER_PROPS = {
  style: {
    top: '64px',
    right: 0,
    height: '100%',
    width: '600px',
    overflow: 'visible',
    zIndex: 1300
  }
}

const ReviewDetailsModal: React.FC = () => {
  const {
    hideModal,
    modalData: { isOpen, entity, review }
  } = useModalData({ modalType: Modals.REVIEW_DETAILS_MODAL })

  return (
    <DrawerModal width={'100%'} isOpen={isOpen} hideModal={hideModal} PaperProps={PAPER_PROPS}>
      <ReviewResultContainer entity={entity} hideModal={hideModal} review={review} />
    </DrawerModal>
  )
}

export default ReviewDetailsModal
